import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, Grid, Button, TextField, Box, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { themePalette } from '../../config/theme.config';
import IresearhService from "../../services/IresearchService";
import { Unidad } from "../../Interface/IUnidad";

export const UnidadAdmin: React.FC = () => {
    const [rows, setRows] = useState<Unidad[]>([]);
    const [loading, setLoading] = useState<boolean>(true); // Estado para el c�rculo de carga
    const [editRow, setEditRow] = useState<Unidad | null>(null);
    const [color, setColor] = useState<string>('');
    const [open, setOpen] = useState<boolean>(false);

    const [isValid, setIsValid] = useState(true);

    // Funci�n para validar el c�digo hexadecimal
    const validateHex = (value: string) => {
        const hexPattern = /^#([0-9A-Fa-f]{3}){1,2}$/;
        return hexPattern.test(value);
    };

    // Manejar cambios en el campo de texto
    const handleColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newColor = e.target.value;
        setColor(newColor);
        setIsValid(validateHex(newColor));
    };

    // Llamada a API para cargar datos
    useEffect(() => {
        setLoading(true); // Activa el estado de carga
        IresearhService.getUnidades()
            .then((unidadesData: { listData: Unidad[] }) => {
                const unidadesAcademicas = unidadesData.listData.filter((unidad) => unidad.idtipounidad === 2);
                setRows(unidadesAcademicas);
            })
            .catch((error) => {
                console.error("Error fetching user data from backend:", error);
            })
            .finally(() => {
                setLoading(false); // Finaliza la carga
            });
    }, []);

    const handleEditClick = (row: Unidad) => {
        setEditRow(row);
        setColor(row.color || '');
        setOpen(true);
    };

    const handleSave = async () => {
        if (!editRow) return;

        try {
            const updatedRow: Partial<Unidad> = { color };
            await axios.put(`/api/unidades/${editRow.idunidad}`, updatedRow);
            setRows(rows.map(row => row.idunidad === editRow.idunidad ? { ...row, color } : row));
            setOpen(false);
        } catch (error) {
            console.error('Error updating data:', error);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const columns: GridColDef[] = [
        { field: 'idunidad', headerName: 'ID', flex: 0.1, resizable: false },
        { field: 'nombreunidad', headerName: 'Unidad', flex: 0.4, resizable: false },
        { field: 'siglas', headerName: 'Siglas', flex: 0.1, resizable: false },
        { field: 'color', headerName: 'Color', flex: 0.2, resizable: false, renderCell: (params) => params.value || 'N/A' },
        {
            field: 'actions',
            headerName: 'Acciones',
            flex: 0.2
            , resizable: false,
            renderCell: (params) => (
                <Button variant="contained" color="primary" onClick={() => handleEditClick(params.row as Unidad)}>
                    Editar
                </Button>
            )
        }
    ];

    return (
        <Container style={{ padding: '20px' }}>
            <Grid container direction="row" justifyContent="space-between" spacing={2} sx={{ borderBottom: `2px solid ${themePalette.NAVCOLOR}` }}>
                <h1>Unidad Admin</h1>
            </Grid>

            {loading ? ( // Mostrar c�rculo de carga mientras se obtienen los datos
                <Box display="flex" justifyContent="center" alignItems="center" height="400px">
                    <CircularProgress />
                </Box>
            ) : (
                <Box sx={{ height: 400, width: '100%', marginTop: '20px' }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        getRowId={(row) => row.idunidad}
                        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
                        pageSizeOptions={[10]}
                    />
                </Box>
            )}

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Editar Color</DialogTitle>
                <DialogContent
                    sx={{
                        width: '400px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}
                >
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Color"
                        type="text"
                        fullWidth
                        value={color}
                        onChange={handleColorChange}
                        error={!isValid}
                        helperText={!isValid ? "Ingresa un c�digo hexadecimal v�lido (ej. #RRGGBB o #RGB)" : ""}
                    />
                    <Box
                        sx={{
                            width: 50,
                            height: 50,
                            backgroundColor: isValid ? color : '#FFFFFF',
                            border: '1px solid #000',
                            marginTop: 2
                        }}
                    />
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button onClick={handleClose}>Cancelar</Button>
                    <Button
                        onClick={handleSave}
                        disabled={!isValid}
                    >
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};
